<button
  *transloco="let t"
  type="button"
  class="flex items-center text-gray-400 dark:text-gray-300 text-md leading-tight cursor-pointer text-left max-w-full"
  matTooltip="{{ (copied() ? t('copied') : t('copy') | titlecase) + ' ' + t(label ?? '') }}"
  [matTooltipPosition]="tooltipPosition"
  [cdkCopyToClipboard]="value ?? ''"
  (cdkCopyToClipboardCopied)="markCopied()"
>
  @if (label) {
    <div class="p-1 border rounded-s-md shrink-0" [ngClass]="{ 'rounded-e-md': !value }">
      {{ t(label) | capitalize }}
    </div>
  }
  @if (value) {
    <!--
      `break-all` + `min-w-0`: o valor pode ser um segredo de 50 caracteres sem espaço nenhum. Sem a
      quebra, ele empurra a largura do container inteiro — foi o que esticou o diálogo do segredo do
      webhook até o limite da viewport.
    -->
    <div
      class="flex items-center gap-2 p-1 border text-current bg-gray-50 dark:bg-gray-700 font-semibold min-w-0 break-all"
      [ngClass]="{ 'rounded-s-md': !label, 'rounded-e-md': true }"
    >
      <span class="min-w-0">{{ value }}</span>

      <!--
        Ícone à DIREITA do valor, virando ✓ ao copiar: sem feedback, quem clica não sabe se copiou — e o
        que está sendo copiado aqui costuma ser exibido uma única vez.
      -->
      <mat-icon
        class="icon-size-4 shrink-0"
        [class.text-green-600]="copied()"
        [svgIcon]="copied() ? 'heroicons_outline:check' : 'heroicons_outline:clipboard-document'"
      ></mat-icon>
    </div>
  }
</button>
